module.exports = __webpack_public_path__ + "img/upcoming-fixtures.072486b9.svg";